import Runner from "./runner";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { version } = require("../package.json");

export { RunStyle } from "./types";
export { Runner, version };
